import { render } from "./GroupTable.vue?vue&type=template&id=0656661e&scoped=true"
import script from "./GroupTable.vue?vue&type=script&lang=js"
export * from "./GroupTable.vue?vue&type=script&lang=js"

import "./GroupTable.vue?vue&type=style&index=0&id=0656661e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0656661e"]])

export default __exports__